import { DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCommentType extends Layout {
    sourceCommentType: DataSource;
    switchActive: Switch;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
